
/**
 * 
 * 
 * @return void
 */
function UrlHelper () {
  
}

/**
 * 
 * 
 * @param string name
 * @param string defaultValue (what to return if not found)
 * @param string url (optional)
 * @return string
 */
 UrlHelper.prototype.getQueryParam = function( name, defaultValue, url ) {
  
  try {
    if( typeof url === "undefined" || url === null ){
      url = window.location.href; // location.href;
    }

    if( typeof defaultValue === "undefined" || defaultValue === null ){
      defaultValue = "";
    }

    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( url );
    return results == null ? defaultValue : results[1];
  } catch (error) {
    console.error( 'Problem in UrlHelper with input ' + name + '. ' + error );
  }

  return defaultValue;
}

export default UrlHelper;
